export default "__VITE_ASSET__DgTr$7rM__"